import { ApolloClient, FetchResult, GraphQLRequest, InMemoryCache, createHttpLink } from "@apollo/client/core";
import { getCurrentStoreConfig } from "@app/config";
import { CustomerUserError } from "@app/gql/fragments";

const config = getCurrentStoreConfig();
const uri = `${config.shopify.url}/api/${config.storefront.apiVersion}/graphql.json`;

const storefrontLink = createHttpLink({
  uri,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "X-Shopify-Storefront-Access-Token": config.storefront.accessToken,
  },
});

export const storefront = new ApolloClient({
  link: storefrontLink,
  cache: new InMemoryCache(),
});

export async function handleStorefrontErrors<Response>(result: FetchResult<Response>) {
  if (result.errors?.length) {
    console.error(result.errors);
    const [error] = result.errors;
    throw Error(error.message);
  }

  if (!result.data) {
    throw Error("Response had no data.");
  }

  return result.data;
}

export async function handleCustomerUserErrors(customerUserErrors?: CustomerUserError[]) {
  if (customerUserErrors?.length) {
    console.error(customerUserErrors);
    const [error] = customerUserErrors;
    throw Error(error.message);
  }
}
